<div #dropdownParent
     [formGroup]="parentForm" [ngClass]="{'show': isFocused, disabled: disabled, 'has-placeholder': hasPlaceholder, 'slim': slim}"
     class="select-dropdown-container {{ className }}" [class.can-clear]="canClear && selectedValue">
  <button (click)="onOpen()" *ngIf="!loading" type="button" [ngClass]="{truncate: truncate}">{{ selectedValueText }}</button>
  <button (click)="onOpen()" *ngIf="loading" type="button"><span aria-hidden="true"
                                                                 class="spinner-border spinner-border-sm"
                                                                 role="status"></span></button>

  <a (click)="reset()" class="clear-icon" *ngIf="canClear && selectedValue"><i class="fas fa-times"></i></a>

  <div class="select-dropdown-items" [ngClass]="{'many-items': options?.length >= 6}">
    <div class="filter-input-container" *ngIf="filterable">
      <input type="text" class="filter-input" placeholder="Search..." [value]="filterText" (input)="onFilterInput($event)" (click)="$event.stopPropagation()" />
      <a class="filter-clear" *ngIf="filterText" (click)="clearFilter(); $event.stopPropagation()"><i class="fas fa-times"></i></a>
    </div>
    <ul>
      <li *ngFor="let option of filteredOptions; let i = index;" class="select-dropdown-item"><a
        (click)="onFilteredItemSelect(i)">{{ option.text }}</a></li>
    </ul>
  </div>

  <select #input [formControlName]="name" *ngIf="name">
    <option *ngFor="let option of options; let i = index;"
            [value]="option.value"
            [selected]="option.value == selectedValue">
      {{ option.text }}
    </option>
  </select>

  <select #input *ngIf="!name" [disabled]="disabled">
    <option *ngFor="let option of options; let i = index;"
            [value]="option.value"
            [selected]="option.value == selectedValue">
      {{ option.text }}
    </option>
  </select>
</div>
